module.exports = __webpack_public_path__ + "img/vinitha_sunkara.b9be1aca.png";